import React from "react";
import styled from "styled-components";

const Wrapper = styled.form`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: relative;
`;

const PageWrapper = ({ children, onSubmit }) => {
  return <Wrapper onSubmit={onSubmit}>{children}</Wrapper>;
};

export default PageWrapper;
